import { inject, Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { PortalInfoResponse } from '../models/portal.model';
import { PortalService } from '../services/portal.service';

@Injectable({ providedIn: 'root' })
export class PageInfoResolver implements Resolve<PortalInfoResponse> {
  private readonly service = inject(PortalService);

  resolve(): Observable<PortalInfoResponse> {
    return this.service.getPageInfo();
  }
}
